
var $ = require('jquery');
var Backbone = require('backbone');

var ReservaTimeTableYearView = Backbone.View.extend({

	events: {
		'click tbody td': 'onClick',
		'click .filter-class-select a': 'changeFilterClass',
		'mouseenter tbody td': 'onHover',
		'mousemove tbody td': 'onHover',
	},

	initialize: function() {
		this.listenTo(this.model, "change:viewData", this.render);
	},

	render: function() {
		let viewData = this.model.get("viewData");
		if ( !viewData ) return;

		if ( !viewData.classes ) {
			viewData.classes = [];
		}

		this.el.innerHTML = TemplateCache.render('reserva-yeartable', viewData);
		this.model.trigger("rendered");
	},

	/*
	 Event Handler
	*/

	onHover: function(e) {
		var $e = $(e.currentTarget);
		var data = $(e.currentTarget).data();
		if ( typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined" ) {
			this.model.cellAction(data, $e, "hover");

			/* Hover for the current day */
			this.highlightDay(data.dayOffset);
		}
	},

	onClick: function(e) {
		var $e = $(e.currentTarget);
		var data = $(e.currentTarget).data();
		if ( typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined" ) {
			this.model.cellAction(data, $e, "click");
		}
	},

	changeFilterClass: function (e) {
		e.preventDefault();
		var data = $(e.currentTarget).data();
		
		this.model.set({
			filterClass: data.class,
		});
	},

	/*
	 API
	*/

	highlightDay: function(dayOffset) {
		this.$el.find('.day-hover').removeClass('day-hover');
		this.$el.find('.day_' + dayOffset).addClass('day-hover');
	},

});

module.exports = ReservaTimeTableYearView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/ReservaTimeTableYearView.js